import { Routes } from "@angular/router";
import { AuthGuard } from "./auth-guard";

export const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    data: { animation: 0, reuse: true },
    loadComponent: () => import('./dashboard/dashboard').then(m => m.Dashboard)
  },
  {
    path: 'gifting',
    canActivate: [AuthGuard],
    data: { animation: 1 },
    loadComponent: () => import('./gifting/giftings').then(m => m.GiftingComponent)
  },
  {
    path: 'itt-tokens',
    canActivate: [AuthGuard],
    data: { animation: 1 },
    loadComponent: () => import('./itt-token/itt-tokens').then(m => m.IttTokens)
  },
  {
    path: 'browse/:member-id',
    canActivate: [AuthGuard],
    data: { animation: 1 },
    loadComponent: () => import('./member-organization-details/member-organization-details').then(m => m.MemberOrganizationDetailsComponent)
  },
  {
    path: 'browse/:member-id/project-listing/:tenant-id/:person-id',
    canActivate: [AuthGuard],
    data: { animation: 1 },
    loadComponent: () => import('./member-organization-details/components/project-listing/project-listing').then(m => m.ProjectListing)
  },
  {
    path: 'browse/:member-id/team-listing/:tenant-id/:person-id',
    canActivate: [AuthGuard],
    data: { animation: 1 },
    loadComponent: () => import('./member-organization-details/components/team-listing/team-listing').then(m => m.TeamListing)
  },
  {
    path: 'transactions/:tenantId/:memberId',
    canActivate: [AuthGuard],
    data: { animation: 2 },
    loadComponent: () => import('./member-organization-details/components/transaction-history/transaction-history').then(m => m.TransactionHistoryComponent)
  },
  {
    path: 'subaccounts/:tenantId/:memberId',
    canActivate: [AuthGuard],
    data: { animation: 2 },
    loadComponent: () => import('./member-organization-details/components/subaccounts/subaccounts').then(m => m.Subaccounts)
  }
];
